<template>
  <div>
    <Ibox :back="true" :titulo="'Seleccione un formulario para usar como base'">
      <b-col cols="12">
        <DataTable
          :loading="loading"
          :columns="columns"
          :rows="rows"
          clases="table-bordered table-hover table-condensed nowrap">
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'desc_habilitado'">
              {{ descHabilitado(props.row) }}
            </span>
            <router-link v-else-if="props.column.field == 'actions'" replace :to="{ name: 'formulario/formulario/copiar', params: { formulario: utils.je64({id_categoria: categoria.id_categoria, id_formulario: props.row.id_formulario, nombre: props.row.nombre}) } }">
              Usar formulario como base
            </router-link>
          </template>
        </DataTable>
      </b-col>
    </Ibox>
  </div>
</template>

<script>
import { formularioService } from '@/services';
import { utils } from '@/helpers';

export default {
  data(){
    return {
      utils,
      loading: true,
      columns:[
        {label: 'Categoria', field: 'nombre_categoria'},
        {label: 'Formulario', field: 'nombre'},
        {label: 'Habilitado', field: 'desc_habilitado'},
        {label: '', field: 'actions'},
        ],
      rows:[],
      categoria: utils.jd64(this.$route.params.categoria)
    }
  },
  mounted () {
    this.cargarDatos();
  },
  methods : {
    cargarDatos(){
      this.loading = true;

      formularioService.getFormularioCategoriaFormularios({}).then(respuesta => {
        this.rows = respuesta.data;
        this.loading = false;
      });
    },
    descHabilitado(row){
      if(row.habilitado == 'S'){
        return 'Si';
      }else{
        return 'No';
      }
    }
  }
}
</script>

<style scoped>
</style>
